// extracted by mini-css-extract-plugin
module.exports = {"BannerSection":"banner-module--BannerSection--1SOI8"};